import { commonTranslationKeys, createTranslatedText, FormContextValues } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { PatientSelectIdentifierType } from '../PatientIdentifierTypeField/PatientIdentifierTypeField';
import { PersonalIdentifierType } from '../../common.types';

import { GenderSelectItem, genderSelectItems, useGenderLabelExtractor } from './GenderField.hooks';
import { StyledSelect } from './GenderField.styled';

type GenderFieldProps = {
   readonly register: FormContextValues['register'];
   readonly personalIdentifierType: PatientSelectIdentifierType;
};

export const GenderField = (props: GenderFieldProps): JSX.Element => {
   return (
      <StyledSelect<GenderSelectItem>
         testId={'gender'}
         triggerLabelExtractor={useGenderLabelExtractor()}
         controller={props.register('gender', {
            required: props.personalIdentifierType.id !== PersonalIdentifierType.MEDICAL_RECORD_NUMBER,
         })}
         placeholder={commonTranslationKeys.choose}
         label={commonTranslationKeys.gender}
      >
         <Select.List items={genderSelectItems} keyExtractor={'id'}>
            {(gender: GenderSelectItem) => (
               <Select.Item
                  item={gender}
                  testId={gender.value}
                  key={gender.value}
                  label={createTranslatedText(gender.name)}
               />
            )}
         </Select.List>
      </StyledSelect>
   );
};
